import { serializeDocument } from 'anodum';

import globals from '../../../globals';
import customHtml from '../../../custom-html';
import bindings from '../../injections/bindings';
import removeOriginFromHTMLString from './remove-origin-from-html-string';

const compose =
  (...functions) =>
  (value) =>
    functions.reduceRight((currentValue, currentFunction) => currentFunction(currentValue), value);

const prepareSerializedStaticDocument = (staticDom) => {
  const preparedDom = compose(
    bindings.disable.removeAll,
    globals.helpers.ejectGlobals,
    customHtml.helpers.ejectCustomHtml
  )(staticDom);
  const serializedDocument = serializeDocument(preparedDom);

  return removeOriginFromHTMLString(serializedDocument);
};

export default prepareSerializedStaticDocument;
